<template>
    <app-screen>
        <div class="reacts-table">
            <waiter ref="waiter">
                <react-data-table
                    ref="table"
                    name="ReactsTableView"
                    :save-state="true"
                    :forms="forms"
                    :row-click-edit="true"
                    :filter="filter"
                    :show-filters="false"
                    :show-search="forms!==true"
                    :allow-add-new="true"
                >
                    <template #beforeActions>
                        <action-back v-if="$route.params.backRoute"></action-back>
                    </template>
                </react-data-table>
            </waiter>
        </div>
    </app-screen>
</template>

<script>
import ReactDataTable from '@/components/ReactDataTable/ReactDataTable'
import isEmpty from '@modules/isEmpty'

export default {
    name: 'ReactsTable',
    components: {ReactDataTable},
    data() {
        return {}
    },
    computed: {
        filter() {
            return ['react_id', 'react_title', 'react_form_name', 'react_user_email']
                .reduce((filter, field) => {
                    if (this.$route.query[field]) {
                        filter[field] = this.$route.query[field]
                    }
                    return filter
                }, {})
        },
        forms() {
            if (this.$route.query.forms && Array.isArray(this.$route.query.forms)) {
                return this.$route.query.forms.map(item => {
                    return {
                        form_id: item
                    }
                })
            } else if (!isEmpty(this.$route.query.forms)) {
                return [{
                    form_id: this.$route.query.forms
                }]
            }
            return true
        }
    },
    activated() {

    },
    methods: {},
}
</script>

<style lang="scss">
</style>
